import { Injectable } from '@angular/core';
import { GenericService } from './generic.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'dashboard');
  }

  financial(startDate, typeDate, endDate = null): Observable<any> {
    let url = `${this.url_base}/${this.prefixo}/financial/${startDate}/${typeDate}`;

    if (endDate != null) {
      url += `?end=${endDate}`;
    }

    return this.http.get(url);
  }
}
